import IsaEditModal from './IsaEditModal';

export default IsaEditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/isaEdit/index.jsx